import { useState } from "react";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import FormButton from "./button";
import FormContent from "./content";

const ItCodeInformation = () => {
  /**
   * Form states
   */
  const [assignList, setAssignList] = useState<any>([]);
  const [iTHeadSelected, setITHeadSelected] = useState(null as any);
  const [iTHeadName, setITHeadName] = useState(null as any);
  const [fileAttachment, setFileAttachment] = useState<any>([]);

  return (
    <InformationLayout>
      <Box title="Thông tin cấp quyền chương trình" className="full-height">
        <FormContent
          setAssignList={setAssignList}
          setITHeadName={setITHeadName}
          setITHeadSelected={setITHeadSelected}
          setFileAttachment={setFileAttachment}
        />

        <FormButton
          assignList={assignList}
          iTHeadName={iTHeadName}
          iTHeadSelected={iTHeadSelected}
          fileAttachment={fileAttachment}
        />
      </Box>
    </InformationLayout>
  );
};

export default ItCodeInformation;
